/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/no-identical-functions */
/*eslint-disable*/
import {
  client,
  client2,
  clientCall,
  clientApiCall,
  defaultClient,
  getJWToken,
  clientCallManageRoute,
  client1
  
} from "./client";
import { appConfig } from "../config/app-config";
import { CancelToken } from "axios";
import jwtDecode from "jwt-decode";
import { ProductPermissions } from '../constants/constants';
import { ApiClientCallParams, FieldSheetResponse, GetCustomerFieldSheetsPayload, StoreConfigsPayload, StoreConfigsResponse, StoreDetailResponse, User } from "../types/types"; 
import { CustSurveyType } from "../domain/Customer/survey";

const InventoryBaseUrl = appConfig.apiUrls.inventory;
const cashmgmtDevUrl = appConfig.apiUrls.cashmgmt;
const storemgmtDevUrl = appConfig.apiUrls.micro;
const customerDevUrl = appConfig.apiUrls.customer;
const agreementDevUrl = appConfig.apiUrls.agreement;
const menuDevUrl = appConfig.apiUrls.menu;
// const customerBaseUrl = appConfig.apiUrls.customer;
// const dashboardBaseUrl = appConfig.apiUrls.dashboard;
export const getCurrentUser = (): Promise<User> =>
  defaultClient(
    "users/current",
    { method: "GET" },
    appConfig.apiUrls.container,
    true
  );

export const getUserPreferences = (productType: string) =>
  client(
    `users/current/preferences/${productType}`,
    { method: "GET" },
    appConfig.apiUrls.container
  );

  export const getUserPermissions = (
    productType: string
  ): Promise<ProductPermissions[]> =>
    client(
      `users/current/permissions/${productType}`,
      { method: 'GET' },
      appConfig.apiUrls.container
    );
export const getRouteDetails = async (storeNumber: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `route/details/${storeNumber}`,
      { method: "GET" },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
//to fetch country code

export const getCustomerStatesList = (country = 'state_province') =>
    clientCall(`references/entity?referenceCode=${country}`, 
    { method: "GET" },
    appConfig.apiUrls.am
  );

// FDC Functions Start
export const GetCustomerinfo = async (agreementId: any) => {
  return await clientCall(
    `agreement/customers/${agreementId}`,
    {
      method: "GET",
    },
    appConfig.apiUrls.agreement
  );
};
export const CheckSign = async (agreementId: string) => {
  return await client1(
    `agreement/delivery-receipt/sign/check/${agreementId}`,
    { method: 'GET' },
    appConfig.apiUrls.agreement
  );
};
export const Recieptsign = async (updatesign: any) => {
  return await clientCall(
    `agreement/delivery/receipt/sign`,
    { method: "PUT", body: updatesign },
    appConfig.apiUrls.agreement
  );
};
export const GetEmployeeID = async () => {
  return await clientCall(
    `user/current`,
    { method: "GET" },
    menuDevUrl
  );
};
export const GenerateAgreementDoc = async (Payload: any) => {
  return await clientCall(
    `agreement/document/generate`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.agreement
  );
};
export const getPrintDocument = async (payload: any) => {
  return await clientCall(
    `agreement/document/print`,
    { method: "POST", body: payload },
    appConfig.apiUrls.agreement
  );
};

export const getReference = async (referenceKey: any[],
  cacheKey: string) : Promise<any[]> => {
  return await clientCall(
    `references`,
    { method: "POST", body: { references: referenceKey, cacheKey }, },
    appConfig.apiUrls.am
  );
};


export const logActivity = async (payload: any) => {
  return await logWorkedHistory(payload);
};

export const generateFieldVisitAnswer = async (payload: any) => {
  const TempAccessToken = "QAToken";
  return await clientCall(
    `update`,
    { method: "POST", body: payload },
    appConfig.apiUrls.micro,
    TempAccessToken,
    true
  );
};

export const logWorkedHistory = async (payload: CustSurveyType) => {
  return await clientCall(
    `customer/logactivity`,
    { method: "POST", body: payload },
    appConfig.apiUrls.am
  );
};


export const FinishdeliveryStatus = async (complete: any) => {
  return await clientCall(
    `agreement/delivery`,
    { method: 'POST', body: complete },
    appConfig.apiUrls.agreement
  );
};
export const GetRole = async (payload: any) => {
  return await clientCall(
    `menu-and-stores`,
    { method: "POST", body: payload },
    menuDevUrl
  );
};
export const GetCustomerId = async (GCID: string) => {
  try {
    return await clientCall(
      `customer/${GCID}/detail`,
      { method: "GET" },
      appConfig.apiUrls.customer
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return "Error";
  }
};


export const getRetentionOffers = async (Payload: any)  => {
  return await clientCall(
    `retention/offers`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.customer
  );
};
export const featureFlags = async (bodyobject: any) => {
  return await clientCall(
    `agreement/address/eventId`,
    { method: "POST", body: bodyobject },
    appConfig.apiUrls.agreement
  );
};

export const GenerateSwitchoutReceipt = async (bodyobj: any) => {
  return await clientCall(
    `agreement/generatereceipt`,
    { method: "POST", body: bodyobj },
    appConfig.apiUrls.agreement
  );
};
// FDC Functions end---------------------------------------------
export const ManageRoute = async (payload: any) => {
  try {
    return await clientCallManageRoute(
      `route/manage`,
      { method: "POST", body: payload },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};
export const GetCoworkerDropDown = async (StoreNumber: any) => {
  // eslint-disable-next-line no-console
  console.log("appConfig agreement", appConfig.apiUrls.agreement);
  return await client2(
    `agreement/options/12345?storeNumber=${StoreNumber}&isSwitchOut=1`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const getmenuandstore = async () => {
  try {
    const jwtToken  = await getJWToken();
    const decodedToken: any = jwtDecode(jwtToken);
    // eslint-disable-next-line no-console
    console.log("decodedToken", decodedToken);
    const parameters = {
      coworkerId: decodedToken["custom:employeeId"],
    };
    return await client2(
      "menu-and-stores",
      { method: "POST", body: parameters },
      menuDevUrl
    );
  } catch (e: any) {
    return null;
  }
};

export const setUserPreferences = (
  productType: string,
  payload: Record<string, any>,
  cancelToken?: CancelToken
) =>
  client(
    `users/current/preferences/${productType}`,
    {
      method: "PATCH",
      body: [payload],
      cancelToken,
    },
    appConfig.apiUrls.container
  );

export const getUserStores = () =>
  client(
    "users/current/stores?q=permissions[:includes]=RACPAD_DAP",
    { method: "GET" },
    appConfig.apiUrls.container
  );
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SendAccessLink = async (UserInfo: any) => {
  const Headers = {
    phoneNumber:
      UserInfo.phoneNumber !== "" &&
      UserInfo.phoneNumber !== undefined &&
      UserInfo.phoneNumber !== null
        ? UserInfo.phoneNumber
        : "",
    emailAddress:
      UserInfo.emailAddress !== "" &&
      UserInfo.emailAddress !== undefined &&
      UserInfo.emailAddress !== null
        ? UserInfo.emailAddress
        : "",
    isOnlyGenerateToken: "false",
  };
  return await clientApiCall(
    `sendaccesslink`,
    { method: "POST", body: UserInfo, headers: Headers },
    appConfig.apiUrls.store,
    "AccessToken",
    false
  );
};
export const updatePinDetails = async (payload: any) => {
  /* eslint-disable no-console */
  // console.log('QA TOKEN', QAToken);
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    return await client2(
      `pin/manage`,
      { method: "POST", body: payload },
      // BaseUrl,
      appConfig.apiUrls.dashboard
    );
  } catch (e: any) {
    
    return e.response;

  }
};
export const GetCloseEndOfDayDetails = async (payload: any) => {
  const responseObj: any = {
    getDrawerDetail: "",
    getPendingEvents: "",
    getPendingCustomerAgreementTransfer: "",
    getTransferReceiveGridDetails: "",
    getPendingAgreementTransfer: "",
  };
  try {
    await Promise.all([
      // GetCustomerInfoOptions(getDrawerDetail),
      // GetCustomerByIdInfo(customerId, storeNumber),
      getDrawerDetail(payload),
      getPendingEvents(payload),
      getPendingCustomerAgreementTransfer(payload),
      getTransferReceiveGridDetails(payload),
      getPendingAgreementTransfer(payload),
    ])
      .then((response) => {
        [
          responseObj.getDrawerDetail,
          responseObj.getPendingEvents,
          responseObj.getPendingCustomerAgreementTransfer,
          responseObj.getTransferReceiveGridDetails,
          responseObj.getPendingAgreementTransfer,
        ] = response;
      })
      .catch((resp) => {
        // eslint-disable-next-line no-console
        console.log("responseObj", resp);
      });
    return responseObj;
  } catch (e: any) {
    return responseObj;
  }
};
export const getPendingAgreementTransfer = async (payload: any) => {
  try {
    return await client2(
      `cashmgmt/drawer/audit/info`,
      { method: "POST", body: payload },
      appConfig.apiUrls.cashmgmt
    );
  } catch (e: any) {
    return null;
  }
};
export const getTransferReceiveGridDetails = async (payload: any) => {
  try {
    return await client2(
      `inventory/transfer/list/${payload.storeNumber}?setNumber=${payload.setNumber}&type=${payload.type}`,
      { method: "GET" },
      InventoryBaseUrl
    );
  } catch (e: any) {
    return null;
  }
};


export const getCustomerAppointment = async (payload: any) => {
  /* eslint-disable no-console */ /* eslint-enable no-console */ /* eslint-enable no-console */ try {
    return await client2(
      `event/search`,
      { method: "POST", body: payload },
      storemgmtDevUrl
    );
  } catch (e: any) {
    return null;
  }
};

export const getCustomerActiveAddress = async (customerId: any) => {
  /* eslint-disable no-console */ /* eslint-enable no-console */ /* eslint-enable no-console */ try {
    return await client2(
      `customer/address/${customerId}?active=Y`,
      { method: 'GET' },
      customerDevUrl
    );
  } catch (e: any) {
    return null;
  }
};

export const getDrawerDetail = async (payload: any) => {
  /* eslint-disable no-console */ /* eslint-enable no-console */ /* eslint-enable no-console */ try {
    return await client2(
      `manage/reconcil`,
      { method: "POST", body: payload },
      cashmgmtDevUrl
    );
  } catch (e: any) {
    return null;
  }
};
export const getDropDocument = async (payload: any) => {
  /* eslint-disable no-console */
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    return await client2(
      `drop/document`,
      { method: "POST", body: payload },
      cashmgmtDevUrl
    );
  } catch (e: any) {
    return null;
  }
};
export const getConfigDetails = async (payload: any) => {
  try {   
    return await client2(
      `store-details`,
      { method: "POST", body: payload },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};
export const GetStatsStatus = async (payload: any) => {
  return await clientCall(
    `store-details`,
    { method: "POST", body: payload },
    appConfig.apiUrls.micro
  );
};
export const manageAgreementTransaction = async (payload: any) => {
  /* eslint-disable no-console */
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    return await client2(
      `manage/transfer`,
      { method: "POST", body: payload },
      agreementDevUrl
    );
  } catch (e: any) {
    return null;
  }
};


export const scheduleDelivery = async (payload: any) => {
  try {
    return await clientCall(
      `agreement/delivery`,
      { method: "POST", body: payload },
      agreementDevUrl
    );
  } catch (e: any) {
    return null;
  }
};
export const getPendingEvents = async (payload: any) => {
  try {
    return await client2(
      `manage/drop`,
      { method: "POST", body: payload },
      cashmgmtDevUrl
    );
  } catch (e: any) {
    return null;
  }
};
export const getPendingCustomerAgreementTransfer = async (payload: any) => {
  try {
    return await client2(
      `agreement/transfers/${payload.storeNumber}?transferType=${payload.transferType}&offset=${payload.offset}`,
      { method: "GET" },
      appConfig.apiUrls.agreement
    );
  } catch (e: any) {
    return null;
  }
};
export const getPinDetails = async (Payload: any) => {
  try {
    return await clientCall(
      `coworker`,
      { method: "POST", body: Payload },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return e;
  }
};
export const getprofileaccess = async (Payload: any) => {
  try {
    return await clientCall(
      `store-access`,
      { method: "POST", body: Payload },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};
export const getsecondfactor = async (Payload: any) => {
  try {
    return await clientCall(
      `coworker-authentication`,
      { method: "POST", body: Payload },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};
export const GetRemoteLoginStatus = async (Payload: any) => {
  return await clientCall(
    `cashmgmt/duo/auth`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro
  );
};
export const UpdateVoidStatus = async (voidobj: any) => {
  return await clientCall(
    `agreement/void/update`,
    { method: "PUT", body: voidobj },
    agreementDevUrl
  );
};

export const GetFscContestDetail = async (payload: any) => {
  let url: any = `fsc/info?isAllDataRequired=${payload.isAllDataRequired}&type=${payload.type}`;
  if (payload.operationCommunicationId) {
    url += `&operationCommunicationId=${payload.operationCommunicationId}`;
  }
  try {
    // eslint-disable-next-line no-console
    console.log("appConfig.apiUrls.dashboard", appConfig.apiUrls.dashboard);
    return await client2(
      url,
      { method: "POST", body: payload },
      appConfig.apiUrls.dashboard
    );
  } catch (e: any) {
    return null;
  }
};
export const UpdateFscContestDetail = async (payload: any) => {
  try {
    return await client2(
      `fsc/manage`,
      { method: "POST", body: payload },
      appConfig.apiUrls.dashboard
    );
  } catch (e: any) {
    return null;
  }
};

export const GetDropDownVals = async (type: any) => {
  try {
    return await client2(
      `association/details?hierarchyType=${type}`,
      { method: "POST" },
      appConfig.apiUrls.dashboard
    );
  } catch (e: any) {
    return null;
  }
};
export const getStateDropDown = async (country: string) => {
  const queryString = country ? `country=${country}` : '';
  return await clientCall(
    `customer/state?${queryString}`,
    { method: "GET" },
    appConfig.apiUrls.customer
  );
};
export const getStoreLookUpDetails = async (payload: any) => {
  return await clientCall(
    `store/lookup`,
    { method: "POST", body: payload },
    appConfig.apiUrls.dashboard
  );
};
export const getDapEvent = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `event/search`,
      { method: "POST", body: payload },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const getStoreTask = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/${payload}`,
      { method: 'GET' },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const getStoreTaskHistory = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/history/${payload}`,
      { method: 'GET' },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const searchStoreTask = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/search`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const createStoreTask = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/create`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const getSalesPersonOptions = async (
  StoreNumber: any
) => {
  const customerId="12345"
  return await clientCall(
    `agreement/options/${customerId}?storeNumber=${StoreNumber}&isSwitchOut=1`,
    { method: 'GET' },
    appConfig.apiUrls.agreement
  );
};
export const updateEventStatus = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `appointment/action`,
      { method: "POST", body: payload },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};

export const getTimeSlot = async (Payload: any) => {
  return await clientCall(
    "agreement/timeslots",
    { method: "POST", body: Payload },
    appConfig.apiUrls.agreement
  );
};
export const EventHistory = async (Payload: any) => {
  return await clientCall(
    "event/history",
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro
  );
};
export const getAgreementDelivery = async (agreementId: any, appointmentId?:any) => {
  return await clientCall(
    `agreement/delivery/info/${agreementId}?appointmentId=${appointmentId}`,
    { method: "Get" },
    appConfig.apiUrls.agreement
  );
};
export const getAgreementInfo = async (AgreementId: any) => {
  return await clientCall(
    `agreement/${AgreementId}`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const getnextpaymentamount = async (Payload: any) => {
  return await clientCall(
    `agreement/getnextpaymentamount`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.agreement
  );
};
export const LoadDeliveryreceipt = async (agreementId: string) => {
  return await clientCall(
    `agreement/delivery/receipt/${agreementId}`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const GenerateReceipt = async (bodyobj: any) => {
  return await clientCall(
    `agreement/generatereceipt`,
    { method: "POST", body: bodyobj },
    appConfig.apiUrls.agreement
  );
};
export const Confirmdelivery = async (updatedeliverystatus: any) => {
  return await clientCall(
    `agreement/delivery/status/update`,
    { method: "PUT", body: updatedeliverystatus },
    appConfig.apiUrls.agreement
  );
};
export const LoadswitchoutDeliveryreceipt = async (agreementId: string) => {
  return await clientCall(
    `agreement/delivery/receipt/${agreementId}?isSwitchOut=1`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const manageAppointment = async (Payload: any) => {
  return await clientCall(
    "event/manage",
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro
  );
};
export const GetReferenceValues = async (param: string) => {
  try {
    return await client2(
      `reference?referenceName=${param}`,
      { method: "GET" },
      appConfig.apiUrls.cashmgmt
    );
  } catch (e: any) {
    return null;
  }
};
export const getInventoryServicingDetails = async (serviceNumber: any) => {
  return await clientCall(
    `inventory/service/details/${serviceNumber}`,
    { method: "GET" },
    InventoryBaseUrl
  );
};
export const postAppointment = async (Payload: any) => {
  return await clientCall(
    "agreement/delivery",
    { method: "POST", body: Payload },
    appConfig.apiUrls.agreement
  );
};
export const managePoAcimaFn = async (bodyobj: any) => {
  return await clientCall(
    `manage/${bodyobj.purchaseOrderNumber}`,
    { method: 'POST', body: bodyobj },
    appConfig.apiUrls.acimapo
  );
};
export const InventoryServicing = async (value: any) => {
  return await clientCall(
    `inventory/service/update`,
    { method: "POST", body: value },
    InventoryBaseUrl
  );
};
export const CoworkerRequired = async (Payload: any) => {
  return await clientCall(
    "store-details",
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro
  );
};
export const LoadInventoryInformation = async (
  inventoryNumber: any,
  type?: any
) => {
  // eslint-disable-next-line no-console
  console.log("invinforeq", inventoryNumber);
  // eslint-disable-next-line no-console
  console.log("type", type);

  return await clientCall(
    `inventory/${inventoryNumber}`,
    { method: "GET" },
    InventoryBaseUrl
  );
};
export const getServiceOptions = async (payload: any) => {
  try {
    return await clientCall(
      "inventory/package/list?isService=1",
      { method: "POST", body: payload },
      InventoryBaseUrl
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return "Error";
  }
};
export const storeException = async (payload: any) => {
  try {
    return await clientCall(
      `agreement/store/exception`,
      { method: "POST", body: payload },
      appConfig.apiUrls.agreement
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return "Error";
  }
};
export const saveSurveyForm = async (Payload: any) => {
  return await clientCall(
    `store/survey/agreement`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro
  );
};
export const getRadiusStores = async (storeId: any) => {
  return await clientCall(
    `radius-stores/${storeId}`,
    { method: "GET" },
    appConfig.apiUrls.micro
  );
};
export const getSavedSurvey = async (agreementId: any) => {
  return await clientCall(
    `store/survey/getagreement/${agreementId}`,
    { method: "GET" },
    appConfig.apiUrls.micro
  );
};
export const GetCustomer = async (customerId: any, payload: any) => {
  return await clientCall(
    `customer/${customerId}`,
    { method: "PUT", body: payload },
    appConfig.apiUrls.customer
  );
};

export const fetchOrganizationDetails = async (Payload: any) => {
  return await clientCall(
    `hierarchy`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.pricing
  );
};

export const getSalesPersonOptions1 = async (Payload: any) => {
  return await clientCall(
    `event/search`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.micro
  );
};

export const getFieldSheets = async (
  payload: GetCustomerFieldSheetsPayload
): Promise<FieldSheetResponse> => {
  return await clientCall(
    `customers/field-sheets`,
    { method: "POST", body: {...payload } },
    appConfig.apiUrls.am
  );
}

export const getStoreConfigs = async (
  payload: StoreConfigsPayload,
  cancelToken?: CancelToken
): Promise<StoreConfigsResponse[]> => {
  return await clientCall(`/config/get-store-profile`,
    {method: 'POST', body: { ...payload }, cancelToken},
    appConfig.apiUrls.am
  );      
};

export const getStoreDetailByNumber = (
  storeNumber: string,  
  cancelToken?: CancelToken
): Promise<StoreDetailResponse> => {
  return client(`stores/${storeNumber}/details`, {
    method: 'GET',
    cancelToken,
  },appConfig.apiUrls.am);
};

export const getVerificationDocuments = async (payload: any) => {
  try {
    return await client2(
      `agreement/document/print`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.agreement
    );
  } catch (e: any) {
    return null;
  }
};
export const SendDOFLink = async (Payload: any) => {
  return await clientCall(
    `intellicheck/sendlink`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.customer
  );
};
export const GetCustomerStgData = async (stgCustomerProfileId: string) => {
  return await clientCall(
    `fetch/${stgCustomerProfileId}`,
    { method: 'Get' },
    appConfig.apiUrls.customer
  );
};

export const makeApiClientCall = async ({ url, method, payload, baseUrl }: ApiClientCallParams) => {
  try {
    const options: { method: string; body?: any } = { method };
    if (payload) {
      options.body = payload;
    }
    return await clientCall(url, options, baseUrl);
  } catch (e: any) {
    return null;
  }
};

